export function getGlobal() {
    return typeof window !== 'undefined'
        ? window
        : typeof global !== 'undefined'
            ? global
            : typeof self !== 'undefined'
                ? self
                : { vocadsIcons: undefined, vocadsIconsRegistered: false };
}
